/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
import './list.tpl.html';

angular
  .module('receipts.list', ['sbsf.constants'])
  /**
   * Controller for the receipts.list template.
   */
  .controller('ReceiptsListCtrl', function ($scope, $state, transactions, orgInfo, VIEW_STATES) {
    $scope.transactions = transactions;
    $scope.headerValues = {
      date: 'timestamp',
      amount: 'txnAmount',
      receiptId: 'id'
    };
    $scope.sfOrgId = orgInfo.sfId;
    $scope.predicate = $scope.headerValues.date;
    $scope.reverse = true;

    /**
     * Handler for when a receipt row is clicked.
     * @param {Object} transaction - A transaction object.
     */
    $scope.goToReceipt = function (transaction) {
      $state.go(VIEW_STATES.RECEIPTS_CONTENT_RECEIPT, {
        receiptId: transaction.id
      });
    };

    /**
     * A getter for the formatter for the date shown in the list.
     *
     * @param {String} timestamp - The timestamp property from a transaction.
     * @returns {string} - A date formatted for display.
     */
    $scope.getDate = function (timestamp) {
      return moment(timestamp).format(SBSF.messages.DOW_M_D_Y);
    };
  });
